const isInteger=value=>Number.isInteger(value);export{isInteger};
